import { isFunction } from "../../data/utils.js";
import { generateUid } from "../../utils/uid.js";

function resolveValue(value, context = null) {

    if (isFunction(value)) {
        if (context)
            return value.call(context);
        return value();
    }

    return value;

}

function randomId(prefix) {

    return (prefix ?? '') + generateUid();

}

/**
 * Returns true only when the flag exists on the options object and its value is strictly true.
 * Missing flags and non-boolean truthy values are treated as disabled.
 */
function isFlagEnabled(options, flagName) {

    if (!options || typeof options !== 'object')
        return false;

    return Object.prototype.hasOwnProperty.call(options, flagName) && options[flagName] === true;

}

/**
 * Returns true only when the flag exists on the options object and its value is strictly false.
 * Missing flags and non-boolean falsy values are not treated as explicitly disabled.
 */
function isFlagDisabled(options, flagName) {

    if (!options || typeof options !== 'object')
        return false;

    return Object.prototype.hasOwnProperty.call(options, flagName) && options[flagName] === false;

}

/**
 * Returns true when the flag is missing or when its value is not strictly true.
 * This is the inverse of isFlagEnabled for option-flag evaluation.
 */
function ifFlagNotEnabled(options, flagName) {

    return !isFlagEnabled(options, flagName);

}

export {
    ifFlagNotEnabled,
    isFlagDisabled,
    isFlagEnabled,
    resolveValue,
    randomId,
};
